import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NewCatalog } from '../../Model/Dto/NewCatalog';
import { Message } from '../../Model/System/Message';
import { CustomerWiki } from '../../Model/System/CustomerWiki';
import { DxDataGridComponent } from 'devextreme-angular';
import { TranslateService } from '@ngx-translate/core';
import { Catalog } from '../../Model/Catalog/Catalog';
import { UserManagementService } from '../../Services/userManagment.service';
import { LoginService } from '../../Services/login.service';
import { SystemService } from '../../Services/system.service';
import { CatalogService } from '../../Services/CatalogManagement/catalog.service';
import { Router } from '@angular/router';
import { custom } from 'devextreme/ui/dialog';
import { SignalrService } from '../../Services/signalr.service';
import { takeUntil } from 'rxjs/operators';
import { ImportContainerService } from "../../Services/DataProcess/import-container.service";
import { ImportContainer } from "../../Model/dataProcess/importContainer";
import { DataSourcesService } from "../../Services/DataProcess/datasources.service";
import { GoldenRecordService } from "../../Services/goldenRecord.service";
import { ExportContainerService } from "../../Services/DataProcess/export-container.service";
import { ExportStageService } from "../../Services/DataProcess/export-stage.service";
import { ExportContainer } from "../../Model/dataProcess/exportContainer";
import { CatalogContainerInfo } from "../../Model/Catalog/CatalogContainerInfo";

@Component({
    selector: 'cat-list',
    templateUrl: './catList.component.html',
    styleUrls: ['./catList.component.css'],
    standalone: false
})
export class CatListComponent implements OnInit {
    @ViewChild(DxDataGridComponent, { static: true }) dataGrid: DxDataGridComponent;

    @Input() containerId: string = null;
    @Input() stage: string = null;

    welcomePopupVisible: boolean = false;
    isDataProcessContainer: boolean = false;
    catalogs: Catalog[] = null;
    backUpVisible: boolean = false;
    jobDataVisible: boolean = false;
    addCatalogVisible: boolean = false;
    newCatalogModel: NewCatalog = new NewCatalog();
    noDataText = '';
    customizeCatalogCount = (itemInfo: { value?: string | number | Date }) =>
        `${itemInfo.value} ${this.translate.instant(itemInfo.value === 1 ? 'Katalog' : 'Kataloge')}`;
    datagridLoaded = false;
    catalogToDelete: Catalog;
    loading: boolean = false;
    lastActiveCatalogId:string;

    containerChooseVisible: boolean = false;
    containerChooseStep: 'choose' | 'list' = 'choose';
    selectedContainerType: string = null;
    selectedCatalogForContainerTransfer: Catalog = null;
    importUsageMode: 'compare' | 'import' = 'compare';
    importUsageItems: { value: 'compare' | 'import'; text: string }[] = [];
    containerObjects: any[] = [];
    containerObjectsLoading: boolean = false;
    newContainerDialogVisible: boolean = false;
    containerTypeForEdit: 'import' | 'export'

    readonly containerTypes = [
        { key: 'import', label: 'Importstage' },
        { key: 'golden', label: 'Golden Record' },
        { key: 'export', label: 'Exportstage' },
    ];
    newImportContainerForCreation: ImportContainer | ExportContainer;

    constructor(
        public loginService: LoginService,
        public systemService: SystemService,
        public translate: TranslateService,
        public userManagment: UserManagementService,
        public catalogService: CatalogService,
        public router: Router,
        public signalrService: SignalrService,
        public importContainerService: ImportContainerService,
        public datasourceService: DataSourcesService,
        public goldenrecordService: GoldenRecordService,
        public exportcontainerService: ExportContainerService,
        public exportStageService: ExportStageService
    ) {
        this.onExpandAll = this.onExpandAll.bind(this);
        this.onCollapseAll = this.onCollapseAll.bind(this);
        this.refresh = this.refresh.bind(this);
        this.duplicateCatalog = this.duplicateCatalog.bind(this);
        this.copyCatalog = this.copyCatalog.bind(this);
        this.createRestorePoint = this.createRestorePoint.bind(this);
        this.showCustomDeleteDialog = this.showCustomDeleteDialog.bind(this);
        this.showCopyToContainerDialog = this.showCopyToContainerDialog.bind(this);
        this.showCreateNewContainerPopUp = this.showCreateNewContainerPopUp.bind(this);
        this.systemService.currentNavigationTitle = this.translate.instant('Katalog Übersicht');
        this.loginService.selectedProductTabIndex = 0;
        this.loginService.selectedCategoryTabIndex = 0;
        this.loginService.selectedCategoryTemplatesTabIndex = 0;
        this.lastActiveCatalogId = this.loginService.currentUser.lastUsedCatalogId;
    }


    ngOnInit(): void {
        this.noDataText = this.translate.instant('keine Kataloge im Account');
        this.importUsageItems = [
            { value: 'compare', text: this.translate.instant('Vergleichen mit Katalog') },
            { value: 'import', text: this.translate.instant('Nur importieren (sichtbar im Katalogarchiv)') }
        ];
        this.refresh();

        this.signalrService.refreshCatalogList$.pipe(takeUntil(this.signalrService.clearSubscriptions$)).subscribe(() => {
            this.catalogService.setCatalogs(this.loginService.currentUser.customerId);
        });
    }

    refresh() {
        this.datagridLoaded = false;
        this.catalogService.selectedCatalogId = null;
        this.catalogService.isJobRunning = false;
        this.catalogService.importCatalogVisible = false;
        if (this.loginService.currentUser == null) {
            this.router.navigate(['/']);
            return;
        }
        this.catalogService.catalog = null;

        this.loadCatalogs();

        if (this.loginService.currentUser.newUser) {
            this.welcomePopupVisible = true;
            this.loginService.currentUser.newUser = false;
            this.loginService.updateUser(this.loginService.currentUser);
        }
    }

    async loadCatalogs() {
        this.catalogService.setCatalogs(this.loginService.currentUser.customerId);
    }

    get model() {
        return this.catalogService.catalogs;
    }

    isGastro(): boolean {
        return this.loginService.currentCustomer.isGastro;
    }

    onRowPrepared(e) {
        if (e.rowType == 'data') {
            if (e.data.isVirtual == true) {
                e.rowElement.style.backgroundColor = '#D6F5F3';
                e.rowElement.className = e.rowElement.className.replace('dx-row-alt', '');
            }

            if (e.data.isDemoCatalog) {
                e.rowElement.style.backgroundColor = 'rgba(255, 122, 89, 0.2)';
                e.rowElement.className = e.rowElement.className.replace('dx-row-alt', '');
            }

            if (e.data.id ==  this.lastActiveCatalogId ) {
                e.rowElement.classList.add('cat-list-active-catalog');
                e.rowElement.className = e.rowElement.className.replace('dx-row-alt', '');
            }
        }
    }

    onExpandAll() {
        this.dataGrid.instance.expandAll();
    }

    onCollapseAll() {
        this.dataGrid.instance.collapseAll();
    }

    get importCatalogVisible(): boolean {
        return this.catalogService.importCatalogVisible;
    }

    set importCatalogVisible(value: boolean) {
        this.catalogService.importCatalogVisible = value;
    }

    getLanguageFlag(language: string) {
        if (!language) return '';

        return this.loginService.getLanguageFlag(language.toLowerCase());
    }

    showAddCatalog() {
        this.addCatalogVisible = true;
    }

    showCustomDeleteDialog(e) {
        let catalogToDeleteIsVirtual = e.row.data.isVirtual;
        this.catalogToDelete = e.row.data;
        const virtualCatalogs = this.catalogService.catalogs.filter(catalog => catalog.isVirtual);
        if (!catalogToDeleteIsVirtual && this.catalogService.catalogs.some(catalog => catalog.isVirtual)) {
            this.systemService.notify(new Message(this.translate.instant("Prüfe Verknüpfungen zu virtuellen Katalogen.")), 1000);
            this.loading = true;
            this.catalogService.checkVirtualCatalogs(this.catalogToDelete.id, this.loginService.currentCustomer.id).then((result: Record<string, number>) => {
                this.loading = false;
                if (Object.keys(result).length > 0) {
                    this.showDeleteDialogWithVirtualCatalogInfo(result, e.row.data.id, e.row.data.customerId);
                } else {
                    this.showDeleteDialog(e.row.data.id, e.row.data.customerId);
                }
            });
        } else {
            this.showDeleteDialog(e.row.data.id, e.row.data.customerId);
        }

    }

    showDeleteDialog(deletedCatalogId: string, customerId: string) {
        let normalCatalogDialog = custom({
            showTitle: true,
            title: this.translate.instant("Katalog löschen"),
            dragEnabled: false,
            messageHtml: this.translate.instant("Wollen Sie den Katalog wirklich löschen?"),

            buttons: [
                {
                    text: this.translate.instant("Ja"),
                    onClick: (e) => {
                        this.onDeleteClicked(deletedCatalogId, customerId);
                    }
                },
                {
                    text: this.translate.instant("Nein"),
                }
            ]
        });
        normalCatalogDialog.show()
    }

    showDeleteDialogWithVirtualCatalogInfo(result: Record<string, number>, deletedCatalogId: string, customerId: string) {
        var rootUrl = window.location.origin;
        var catalog: Catalog;
        let messageText = "<p>" + this.translate.instant("DeleteNoteVirtualCatalogs") + " <a href='https://knowledge.nextpim.de/wichtige-funktionen#virtuelle-kataloge' target='_blank'>nextPIM Wiki</a>.</p><p>Anzahl Verlinkungen:</p>" +
            "<table><th>Katalog</th><th>Anzahl</th>";
        for (const [key, value] of Object.entries(result)) {
            catalog = this.catalogService.catalogs.find(cat => cat.id == key);
            if (catalog) {
                messageText += `<tr><td><a href="${rootUrl}/catalog/${this.loginService.currentCustomer.id}/${catalog.id}/info">${catalog.catalogName}</a></td><td style="text-align: center; vertical-align: middle;">${value}</td></tr>`;
            }
        }
        messageText += "</table>";

        let virtualCatalogDialog = custom({
            showTitle: true,
            title: this.translate.instant("Katalog löschen"),
            dragEnabled: false,
            messageHtml: messageText,

            buttons: [{
                text: "Löschen bestätigen",
                onClick: (e) => {
                    this.onDeleteClicked(deletedCatalogId, customerId);
                }
            },
                {
                    text: "Abbrechen",
                    onClick: (e) => {
                    }
                },
            ]
        });
        virtualCatalogDialog.show();
    }


    showImportCatalog() {
        this.catalogService.importCatalogVisible = true;
    }

    onEditClicked(e) {
        this.catalogService.selectedCatalogId = e.key.id;
        this.router.navigate(['/catalog/' + e.key.customerId + '/' + e.key.id + '/info']);
    }

    catalogSelected(data: Catalog) {
        this.catalogService.selectedCatalogId = data.id;
        this.catalogService.browseRoutePrefix = '';
        this.loginService.currentUser.lastUsedCatalogId = data.id;
        this.loginService.updateUser();
        this.router.navigate(['/catalog/' + data.customerId + '/' + data.id + '/info']);
    }

    updateResponsible(data) {
        this.catalogService.setResponsible();
        this.catalogService.catalog = data.data;
        this.catalogService.updateCatalog();
    }

    update(data) {
        this.catalogService.catalog = data.data;
        this.catalogService.updateCatalog();
    }

    duplicateCatalog(e) {
        this.translate.get("Der Katalog wird dupliziert").subscribe((text: string) => {
            this.systemService.notify(new Message(text));
        });
        this.catalogService.duplicateCatalog(e.row.data.id);
    }

  

    createRestorePoint(e) {
        this.translate.get("Ein Wiederherstellungspunkt wird per Job erzeugt").subscribe((text: string) => {
            this.systemService.notify(new Message(text));
        });
        this.catalogService.createRestorePoint(e.row.data.id);
    }

    onDeleteClicked(deletedCatalogId: string, customerId: string) {
        if (
            this.loginService.currentCustomer.licenseId == "078ba77d-ebe1-477d-bdae-771221c29141" &&
            this.catalogToDelete.isDemoCatalog && !this.loginService.isAdmin
        ) {
            this.systemService.notifyInfo(
                this.translate.instant(
                    'Demo-Katalog kann nicht gelöscht werden.'
                )
            );
        } else {

            this.catalogService.remCatalog(this.catalogToDelete.id);
        }
        setTimeout(() => {
            this.refresh();
        }, 200);
        this.importContainerService.deleteContainerCatalogsByCatalogId(deletedCatalogId, customerId);
    }


    copyCatalog(e) {
        this.catalogService.copyCatalogId = e.row.data.id;
        this.catalogService.copyCatalogCustomerId = this.loginService.currentUser.customerId;
    }

    pasteCatalog() {
        this.translate.get('Katalog wird eingefügt').subscribe((text: string) => {
            this.systemService.notify(new Message(text));
        });

        this.catalogService.duplicateCatalog(this.catalogService.copyCatalogId, this.catalogService.copyCatalogCustomerId);
    }

    get fullScreen() {
        return this.catalogService.viewService.fullScreen;
    }

    set fullScreen(value: boolean) {
        this.catalogService.viewService.fullScreen = value;
    }

    toFullScreen() {
        this.catalogService.viewService.fullScreen = true;
    }

    toWindow() {
        this.catalogService.viewService.fullScreen = false;
    }

    hideExport() {
        this.catalogService.exportVisible = false;
    }

    showBackUp() {
        this.backUpVisible = true;
    }

    hideBackUp() {
        this.backUpVisible = false;
    }

    showJobData() {
        this.jobDataVisible = true;
    }

    hideJobData() {
        this.jobDataVisible = false;
    }

    toggleHelp() {
        this.systemService.showHelp = !this.systemService.showHelp;
        if (this.systemService.showHelp) {
            this.systemService
                .loadHelp(this.loginService.currentUser.customerId)
                .subscribe((result: CustomerWiki) => (this.systemService.help = result.entries));
        }
    }

    //SETTINGS
    get showToolTips(): boolean {
        return this.loginService.showToolTips;
    }

    get showProToolTips(): boolean {
        return this.loginService.showProToolTips;
    }

    get showPlaceHolders(): boolean {
        return this.loginService.showPlaceHolders;
    }

    mimedate() {
        return '?' + new Date().toDateString;
    }

    imageVisable: boolean = false;
    source: string = '';
    target: string = '';

    showImage(source, index) {
        if (source != null) {
            this.target = '#link' + index;
            this.source = source;
            this.imageVisable = true;
        }
    }

    hideImage() {
        this.imageVisable = false;
    }

    memoVisable: boolean = false;
    memoText: string = '';
    memoTarget: string = '';

    showMemo(memo) {
        if (memo.data.memo != null) {
            this.memoTarget = '#memo' + memo.rowIndex;
            this.memoText = memo.data.memo;
            this.memoVisable = true;
        }
    }

    hideMemo() {
        this.memoVisable = false;
    }

    canView(name: string): boolean {
        return this.userManagment.canView(name);
    }

    canEdit(name: string, catalog: Catalog = null): boolean {
        return this.userManagment.canEdit(name, catalog);
    }

    showCopyToContainerDialog(e) {
        this.selectedCatalogForContainerTransfer = e.row.data;
        this.containerChooseStep = 'choose';
        this.selectedContainerType = null;
        this.importUsageMode = 'compare';
        this.containerObjects ??= [];
        this.containerChooseVisible = true;
    }

    selectContainerType(type: string) {
        this.selectedContainerType = type;
        this.containerChooseStep = 'list';
        this.loadContainerObjects();
    }

    async loadContainerObjects() {
        this.containerObjectsLoading = true;
        this.containerObjects = [];
        try {
            switch (this.selectedContainerType) {
                case 'import':
                    var allImportContainers = await this.importContainerService.getAll(this.loginService.currentUser.customerId);
                    var sorted = allImportContainers.sort((a, b) =>
                      a.name  > b.name  ? 1 : a.name  < b.name  ? -1 : 0
                    );
                  
                  this.containerObjects = sorted;
                    break;
                case 'export':
                    var exportStageDummy = { name: this.translate.instant("Exportstage") }
                    this.containerObjects = [exportStageDummy];
                    break;
                case 'golden':
                    var goldenRecordDummy = { name: "Goldenrecord anlegen" }
                    this.containerObjects = [goldenRecordDummy];
                    break;
            }
        } finally {
            this.containerObjectsLoading = false;
        }
    }

    backToContainerChoose() {
        this.containerChooseStep = 'choose';
        this.selectedContainerType = null;
        this.containerObjects = [];
    }

    hideContainerChoose() {
        this.containerChooseVisible = false;
    }

    async onContainerObjectSelected(e) {
        const selected = e.itemData;
        switch (this.selectedContainerType) {
            case 'import':
                if (!this.checkForDuplicateInContainer(selected, this.selectedCatalogForContainerTransfer)) {
                    const newCatalogId = this.selectedCatalogForContainerTransfer.id;
                    selected.catalogIds ??= [];
                    selected.catalogIds.push(newCatalogId);

                    if (this.importUsageMode === 'compare') {
                        const previousActiveCatalogId = selected.activeCatalogId;
                        selected.activeCatalogId = newCatalogId;
                        selected.compareCatalogId = previousActiveCatalogId || null;
                    }

                    await this.importContainerService.update(selected, this.loginService.currentUser.customerId);
                    this.systemService.notify(new Message(this.translate.instant("Katalog in Container verschoben!")), 2000);

                    const newContainerInfo: CatalogContainerInfo = {
                        containerId: selected.id,
                        containerName: selected.name,
                        containerType: this.selectedContainerType
                    };
                    this.selectedCatalogForContainerTransfer.containers ??= [];
                    this.selectedCatalogForContainerTransfer.containers.push(newContainerInfo);

                    this.containerChooseVisible = false;
                }
                break;
            case "golden":
                if (!await this.checkForDuplicateInGoldenRecord(this.selectedCatalogForContainerTransfer)) {
                    await this.goldenrecordService.addCatalogToStage(this.selectedCatalogForContainerTransfer.id, this.loginService.currentUser.customerId);
                    this.systemService.notify(new Message(this.translate.instant("Katalog in Golden Record verschoben!")), 2000);

                    const newContainerInfo: CatalogContainerInfo = {
                        containerId: "",
                        containerName: "Golden Record",
                        containerType: "Golden Record"
                    };
                    this.selectedCatalogForContainerTransfer.containers ??= [];
                    this.selectedCatalogForContainerTransfer.containers.push(newContainerInfo);

                    this.containerChooseVisible = false;
                }
                break;
            case 'export':
                if (!this.checkForDuplicateInExportStage(this.selectedCatalogForContainerTransfer)) {
                    await this.exportStageService.addCatalogToStage(this.selectedCatalogForContainerTransfer.id, this.loginService.currentUser.customerId);
                    this.systemService.notify(new Message(this.translate.instant("Katalog in die Exportstage verschoben!")), 2000);

                    const newContainerInfo: CatalogContainerInfo = {
                        containerId: "",
                        containerName: this.translate.instant("Exportstage"),
                        containerType: "Export"
                    };
                    this.selectedCatalogForContainerTransfer.containers ??= [];
                    this.selectedCatalogForContainerTransfer.containers.push(newContainerInfo);

                    this.containerChooseVisible = false;
                }
                break;
        }

    }

    checkForDuplicateInExportStage(selectedCatalog: Catalog): boolean {
        var stageAlreadyIncludesCatalog = selectedCatalog.containers?.some(c => c.containerType === "Export") ?? false;
        if (stageAlreadyIncludesCatalog) {
            this.systemService.notifyWarning(this.translate.instant("Katalog im Ziel bereits vorhanden."), 2000);
        }
        return stageAlreadyIncludesCatalog;
    }

    checkForDuplicateInContainer(chosenImportContainer: ImportContainer, selectedCatalog: Catalog): boolean {
        var containerAlreadyIncludesCatalog = chosenImportContainer.catalogIds?.includes(selectedCatalog.id) ?? false;
        if (containerAlreadyIncludesCatalog) {
            this.systemService.notifyWarning(this.translate.instant("Katalog im Ziel bereits vorhanden."), 2000);
        }
        return containerAlreadyIncludesCatalog;
    }

    async checkForDuplicateInGoldenRecord(selectedCatalog: Catalog): Promise<boolean> {
        var stage = await this.goldenrecordService.getGoldenRecordStage(this.loginService.currentUser.customerId);
        var containerAlreadyIncludesCatalog = stage?.catalogIds?.includes(selectedCatalog.id) ?? false;

        if (containerAlreadyIncludesCatalog) {
            this.systemService.notifyWarning(this.translate.instant("Katalog im Ziel bereits vorhanden."), 2000);
        }
        return containerAlreadyIncludesCatalog;
    }

    get selectedContainerTypeLabel(): string {
        const found = this.containerTypes.find(t => t.key === this.selectedContainerType);
        return found ? found.label : '';
    }

    async showCreateNewContainerPopUp() {
        switch (this.selectedContainerType) {
            case 'import':
                this.containerTypeForEdit = "import";
                this.newImportContainerForCreation = new ImportContainer();
                break;
        }
        this.newImportContainerForCreation.catalogIds ??= [];
        this.newImportContainerForCreation.catalogIds.push(this.selectedCatalogForContainerTransfer.id)

        if (this.selectedContainerType === 'import' && this.importUsageMode === 'compare') {
            (this.newImportContainerForCreation as ImportContainer).activeCatalogId = this.selectedCatalogForContainerTransfer.id;
        }

        const supplierName = this.selectedCatalogForContainerTransfer?.supplier?.supplierName;
        if (supplierName) {
            this.newImportContainerForCreation.name = supplierName;
            const productDataSourceMatchedByName = await this.datasourceService.getDataSourceByName(supplierName, this.loginService.currentCustomer.id);
            if (productDataSourceMatchedByName) {
                this.newImportContainerForCreation.dataSourceId = productDataSourceMatchedByName.id;
            }
        }

        this.newContainerDialogVisible = true;
    }

    onContainerSaved(event: any) {
        var savedContainer = event;

        const newContainerInfo: CatalogContainerInfo = {
            containerId: savedContainer.id,
            containerName: savedContainer.name,
            containerType: this.selectedContainerType
        };

      this.selectedCatalogForContainerTransfer.containers ??= [];
        this.selectedCatalogForContainerTransfer.containers.push(newContainerInfo);

        this.containerObjects.push(this.newImportContainerForCreation);
      this.containerChooseVisible = false;
    }

    displayContainersUsedByCatalog(rowdata: any): string {
        var currentCatalog = rowdata;
        if (currentCatalog?.containers == null) {
            return "";
        }
        var usedContainerNames = currentCatalog.containers.map(x => x.containerName).join(",");
        return usedContainerNames;
    }

    displayContainerTypesUsedByCatalog(rowdata: any): string {
        var currentCatalog = rowdata;
        if (currentCatalog?.containers == null) {
            return "";
        }
        var usedContainerStages = currentCatalog.containers.map(x => x.containerType);
        var uniqueUsedContainerStages = [...new Set(usedContainerStages)];

        return uniqueUsedContainerStages.join(', ');
    }

    displayCatalogState(rowdata: any): string {
        return (rowdata?.catalogState ?? []).join(', ');
    }

    catalogStateFilterExpression = (filterValue: string, selectedFilterOperation: string, target: string): ((rowData: any) => boolean) => {
        return (rowData: any) => {
            var states = this.getCatalogStates(rowData);

            if (target === 'search') {
                var searchText = (filterValue ?? '').toLowerCase();
                return states.some(state => state.toLowerCase().includes(searchText));
            }

            if (filterValue == null || filterValue === '') {
                return states.length === 0;
            }

            return states.includes(filterValue);
        };
    };

    catalogStateHeaderFilterDataSource = (options: any): void => {
        var catalogs = (this.model ?? []) as any[];
        var states = catalogs.flatMap(catalog => this.getCatalogStates(catalog));
        var uniqueStates = [...new Set(states)].sort().map(state => ({ text: state, value: state }));

        if (catalogs.some(catalog => this.getCatalogStates(catalog).length === 0)) {
            uniqueStates.unshift({ text: '', value: '' });
        }

        options.dataSource = uniqueStates;
    };

    private getCatalogStates(catalog: any): string[] {
        return ((catalog?.catalogState ?? []) as string[]).filter(state => state != null && state !== '');
    }

    containerNameFilterExpression = (filterValue: string): ((rowData: any) => boolean) => {
        return this.buildContainerFilter(filterValue, c => c.containerName);
    };

    containerTypeFilterExpression = (filterValue: string): ((rowData: any) => boolean) => {
        return this.buildContainerFilter(filterValue, c => c.containerType);
    };

    containerNameHeaderFilterDataSource = (options: any): void => {
        options.dataSource = this.getUniqueContainerValues(c => c.containerName);
    };

    containerTypeHeaderFilterDataSource = (options: any): void => {
        options.dataSource = this.getUniqueContainerValues(c => c.containerType);
    };

    private buildContainerFilter(filterValue: string, selector: (c: CatalogContainerInfo) => string): (rowData: any) => boolean {
        return (rowData: any) => {
            var values = ((rowData?.containers ?? []) as CatalogContainerInfo[])
                .map(selector)
                .filter(value => value != null && value !== '');

            if (filterValue == null || filterValue === '') {
                return values.length === 0;
            }

            return values.includes(filterValue);
        };
    }

    private getUniqueContainerValues(selector: (c: CatalogContainerInfo) => string): { text: string; value: string }[] {
        var catalogs = (this.model ?? []) as any[];
        var hasValue = (catalog: any) => ((catalog?.containers ?? []) as CatalogContainerInfo[])
            .some(c => selector(c) != null && selector(c) !== '');

        var values = catalogs
            .flatMap((catalog: any) => (catalog?.containers ?? []) as CatalogContainerInfo[])
            .map(selector)
            .filter(value => value != null && value !== '');

        var uniqueValues = [...new Set(values)].sort().map(value => ({ text: value, value: value }));

        if (catalogs.some(catalog => !hasValue(catalog))) {
            uniqueValues.unshift({ text: '', value: '' });
        }

        return uniqueValues;
    }
}
